// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__iY0l0","buttons":"PendingPaymentAlert_buttons__ik-v2"};